"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedPriceSaleProgram = void 0;
const mpl_core_1 = require("@metaplex-foundation/mpl-core");
const generated_1 = require("./generated");
class FixedPriceSaleProgram extends mpl_core_1.Program {
}
exports.FixedPriceSaleProgram = FixedPriceSaleProgram;
FixedPriceSaleProgram.PUBKEY = generated_1.PROGRAM_ID;
//# sourceMappingURL=FixedPriceSale.js.map